import React from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ResultsSection() {
  const shortTerm = ['Menos despertares', 'Menos hambre', 'Mejor descanso'];
  const longTerm = ['Duermes 5-6 horas seguidas', 'Menos ansiedad', 'Barriga menos inflamada'];
  return <section className="py-24 bg-cream-alt relative" data-id="element-188">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-189">
        <FadeIn data-id="element-190">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-charcoal mb-4" data-id="element-191">
            Esto es lo que cambia cuando aplicas el sistema:
          </h2>
          <p className="text-lg md:text-xl text-charcoal-light text-center mb-16" data-id="element-192">
            Estos cambios no son milagros. Son lo que ocurre cuando tu cuerpo
            vuelve a funcionar como debería.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-193">
          <FadeIn delay={0.1} data-id="element-194">
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-warm-md border border-terracotta/10 h-full relative overflow-hidden" data-id="element-195">
              <div className="absolute top-0 right-0 w-32 h-32 bg-terracotta/5 rounded-bl-full" data-id="element-196"></div>
              <h3 className="text-2xl font-serif font-bold text-terracotta-dark mb-8 border-b border-cream-dark pb-4" data-id="element-197">
                En 7 días:
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-198">
                {shortTerm.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-199">
                    <div className="bg-terracotta/10 p-2 rounded-full text-terracotta" data-id="element-200">
                      <Check className="w-5 h-5" strokeWidth={3} data-id="element-201" />
                    </div>
                    <span className="text-lg font-medium text-charcoal" data-id="element-202">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-203">
            <div className="bg-terracotta rounded-3xl p-8 md:p-12 shadow-volumetric text-white h-full relative overflow-hidden" data-id="element-204">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full" data-id="element-205"></div>
              <h3 className="text-2xl font-serif font-bold text-white mb-8 border-b border-white/20 pb-4" data-id="element-206">
                En 3 semanas:
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-207">
                {longTerm.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-208">
                    <div className="bg-white/20 p-2 rounded-full text-white" data-id="element-209">
                      <Check className="w-5 h-5" strokeWidth={3} data-id="element-210" />
                    </div>
                    <span className="text-lg font-medium text-white" data-id="element-211">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}